<template>
    <modal id="outOfStockModal">
        <template slot="header">
            <button type="button" class="close close-popup" data-dismiss="modal" aria-label="Close"><span
                    aria-hidden="true">×</span></button>
            <h2 class="modal-title">You have out of stock item(s) in your cart</h2>
        </template>
        <ul style="padding-left:20px">
          <li v-for="item in items">
          {{ item.product.name }}, {{ item.product.sku }}
          </li>
        </ul>
        <br>
        <p>
          Click <b>Notify Me</b> to be notified when product(s) are back in stock and receive free overnight shipping up to 12 lbs.
          <br>
          By selecting Notify Me, your out of stock item(s) will be removed.
          <br><br>
          OR
          <br><br>
          For no notification, click the OK button and the out of stock item(s) will be removed.
        </p>

        <template slot="footer">
          <button type="button" @click.prevent="subscribe" class="btn btn-light-green">Notify Me</button>
          <button type="button" @click.prevent="close" class="btn btn-black">Ok</button>
        </template>
    </modal>
</template>

<script>
  export default {
    name: 'out-of-stock-modal',

    props: {
      items: Array
    },

    methods: {
      close() {
        for (let item of this.items) {
          const url = `/api/proxify/domains/prismatic/shop/cart/items/${item.id}`;
          axios.delete(url, {data: {}})
            .then(response => {
              if(response.status / 100 === 2) {
                let responsedata = {};
                if (response.data != undefined) {
                  responsedata = response.data;
                } else {
                  responsedata = response;
                }
                window.appVariables.bus.$emit('cart-updated', responsedata);
                if (responsedata.savings.amount > 0) {
                  this.$parent.$parent.formSuccess = [];
                  for (const appliedDiscount of responsedata.applied_discounts) {
                    this.$parent.$parent.getDiscountMessage(appliedDiscount, responsedata);
                  }
                }
              }
            })
            .catch(response => {
                console.log(response);
            })
        }

        $(this.$el).modal('hide');
      },
      subscribe() {

        for (let item of this.items) {
          let payload = {
            email: this.$root.me.primary_email,
            sku: item.product.sku,
            quantity: item.quantity.value
          }
          axios.post('/api/proxify/domains/prismatic/shop/out-of-stock', payload)
            .then(response => {
            })
            .catch(response => {
              console.log(response);
            })

          const url = `/api/proxify/domains/prismatic/shop/cart/items/${item.id}`;
          axios.delete(url, {data: {}})
            .then(response => {
              if(response.status / 100 === 2) {
                let responsedata = {};
                if (response.data != undefined) {
                  responsedata = response.data;
                } else {
                  responsedata = response;
                }
                window.appVariables.bus.$emit('cart-updated', responsedata);
                if (responsedata.savings.amount > 0) {
                  this.$parent.$parent.formSuccess = [];
                  for (const appliedDiscount of responsedata.applied_discounts) {
                    this.$parent.$parent.getDiscountMessage(appliedDiscount, responsedata);
                  }
                }
              }
            })
            .catch(response => {
                console.log(response);
            })
        }

        $(this.$el).modal('hide');
      }
    }
  }
</script>
